import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { toast } from 'sonner'
import useSWR from 'swr'

import { Loading } from '@/components/Loading'
import { SettingsPage } from '@/containers/Settings/SettingsLayout'
import { apiFetcher } from '@/data/fetcher'
import { StandaloneParticipantForm } from '@/forms/ParticipantForm/StandaloneParticipantForm'
import { Settings } from '@/interfaces/Settings'
import API from '@/lib/api'

export default function SettingsSupplierPage({ ref }: { ref?: string }) {
  const navigate = useNavigate()
  const { t } = useTranslation(undefined, {
    keyPrefix: 'settings',
  })

  const {
    data: settings,
    isLoading,
    mutate,
  } = useSWR<Settings>('/api/v2/settings', apiFetcher)

  return (
    <SettingsPage
      title="Fakturační údaje"
      description="Údaje dodavatele, které se tisknou na každý doklad. Firmu najdete podle názvu nebo IČO v ARES."
      breadcrumbHref="/settings/supplier"
    >
      {isLoading && <Loading />}

      {settings && (
        <StandaloneParticipantForm
          type="supplier"
          defaultValues={
            settings.participant
              ? {
                  supplier: {
                    ...settings.participant,
                    businessId: settings.participant.ico,
                    taxId: settings.participant.dic,
                  },
                }
              : undefined
          }
          showAccountNumber
          onSuccess={(data) => {
            if (settings.participantId === null) {
              API.patch('/api/v2/settings', {
                participantId: data.id,
              }).then(() => {
                toast.success(t('invoicing.supplier.success.title'))

                if (ref === 'invoice') {
                  setTimeout(() => {
                    navigate('/invoice/new')
                  }, 1000)
                } else {
                  mutate()
                }
              })
            } else {
              toast.success(t('invoicing.supplier.success.title'))
            }

            // router.reload()
          }}
        />
      )}
    </SettingsPage>
  )
}
